import {
  RISK_LEVELS,
  REVIEW_STATES,
  DECISIONS,
  FINDING_SEVERITY,
  FINDING_STATUS,
  CRITERIA_RESULTS,
  ASSESSMENT_STATUS,
  SECURITY_REVIEW_STATUS,
  RECOMMENDATIONS,
} from "./constants";

const chipBase = (theme, colors) => ({
  minWidth: "90px",
  height: "28px",
  fontWeight: 600,
  fontSize: "0.75rem",
  border: "none",
  borderRadius: 0,
  boxShadow: theme.customColors.shadow.main,
  backgroundColor: colors.bg,
  color: colors.color,
});

export const getRiskChipColors = (theme, level) => {
  const status = theme.customColors.status;
  switch (level) {
    case RISK_LEVELS.CRITICAL:
    case RISK_LEVELS.HIGH:
      return { bg: status.error.bg, color: status.error.text };
    case RISK_LEVELS.MEDIUM:
      return { bg: status.warning.bg, color: status.warning.text };
    case RISK_LEVELS.LOW:
      return { bg: status.success.bg, color: status.success.text };
    default:
      return {
        bg: theme.customColors.background.light,
        color: theme.customColors.text.secondary,
      };
  }
};

export const getRiskChipSx = (theme, level) =>
  chipBase(theme, getRiskChipColors(theme, level));

export const getStatusChipColors = (theme, label) => {
  const status = theme.customColors.status;
  const muted = {
    bg: theme.customColors.background.light,
    color: theme.customColors.text.secondary,
  };

  const map = {
    [REVIEW_STATES.UPCOMING]: muted,
    [REVIEW_STATES.DUE_SOON]: { bg: status.warning.bg, color: status.warning.text },
    [REVIEW_STATES.DUE]: { bg: status.pending.bg, color: status.pending.text },
    [REVIEW_STATES.OVERDUE]: { bg: status.error.bg, color: status.error.text },
    [REVIEW_STATES.COMPLETED]: { bg: status.success.bg, color: status.success.text },
    [DECISIONS.APPROVE]: { bg: status.success.bg, color: status.success.text },
    [DECISIONS.APPROVE_WITH_EXCEPTIONS]: { bg: status.warning.bg, color: status.warning.text },
    [DECISIONS.REJECT]: { bg: status.error.bg, color: status.error.text },
    Approve: { bg: status.success.bg, color: status.success.text },
    Reject: { bg: status.error.bg, color: status.error.text },
    [FINDING_SEVERITY.CRITICAL]: { bg: status.error.bg, color: status.error.text },
    [FINDING_SEVERITY.HIGH]: { bg: status.error.bg, color: status.error.text },
    [FINDING_SEVERITY.MEDIUM]: { bg: status.warning.bg, color: status.warning.text },
    [FINDING_SEVERITY.LOW]: { bg: status.success.bg, color: status.success.text },
    [FINDING_STATUS.OPEN]: { bg: status.error.bg, color: status.error.text },
    [FINDING_STATUS.IN_REMEDIATION]: { bg: status.warning.bg, color: status.warning.text },
    [FINDING_STATUS.ACCEPTED]: { bg: status.info.bg, color: status.info.text },
    [FINDING_STATUS.CLOSED]: { bg: status.success.bg, color: status.success.text },
    [CRITERIA_RESULTS.PASS]: { bg: status.success.bg, color: status.success.text },
    [CRITERIA_RESULTS.FAIL]: { bg: status.error.bg, color: status.error.text },
    [CRITERIA_RESULTS.PARTIAL]: { bg: status.warning.bg, color: status.warning.text },
    [CRITERIA_RESULTS.NOT_ASSESSED]: muted,
    [ASSESSMENT_STATUS.NOT_STARTED]: muted,
    [ASSESSMENT_STATUS.IN_PROGRESS]: { bg: status.info.bg, color: status.info.text },
    [ASSESSMENT_STATUS.IN_REVIEW]: { bg: status.warning.bg, color: status.warning.text },
    [ASSESSMENT_STATUS.COMPLETED]: { bg: status.success.bg, color: status.success.text },
    [SECURITY_REVIEW_STATUS.DRAFT]: { bg: status.warning.bg, color: status.warning.text },
    [SECURITY_REVIEW_STATUS.DISCARDED]: { bg: status.error.bg, color: status.error.text },
    [RECOMMENDATIONS.APPROVED]: { bg: status.success.bg, color: status.success.text },
    [RECOMMENDATIONS.CONDITIONALLY_APPROVED]: { bg: status.warning.bg, color: status.warning.text },
    [RECOMMENDATIONS.NOT_APPROVED]: { bg: status.error.bg, color: status.error.text },
    Valid: { bg: status.success.bg, color: status.success.text },
    Requested: { bg: status.warning.bg, color: status.warning.text },
    Expired: { bg: status.error.bg, color: status.error.text },
    Critical: { bg: status.error.bg, color: status.error.text },
    High: { bg: status.error.bg, color: status.error.text },
    Medium: { bg: status.warning.bg, color: status.warning.text },
    Info: { bg: status.info.bg, color: status.info.text },
  };

  return map[label] || muted;
};

export const getStatusChipSx = (theme, label) =>
  chipBase(theme, getStatusChipColors(theme, label));
